import { configureStore } from "@reduxjs/toolkit";
import favoritosReducer from "./slices/FavouriteSlice";
import uploadReducer from "./slices/uploadSlice";
import authReducer from "./slices/authSlice";
import moviesReducer from "./slices/moviesSlice";
import usersReducer from "./slices/usersSlice";
import plansReducer from "./slices/plansSlice";
import notificationsReducer from "./slices/notificationsSlice";
import recommendationsReducer from "./slices/recommendationsSlice";
import animesReducer from "./slices/animeSlice";
import seasonsReducer from "./slices/seasonSlice";
import episodesReducer from "./slices/episodeSlice";
import seriesReducer from "./slices/seriesSlice";

export const store = configureStore({
  reducer: {
    favoritos: favoritosReducer,
    upload: uploadReducer,
    auth: authReducer,
    movies: moviesReducer,
    users: usersReducer,
    plan: plansReducer,
    notifications: notificationsReducer,
    recommendations: recommendationsReducer,
    animes: animesReducer,
    series: seriesReducer,
    seasons: seasonsReducer,
    episodes: episodesReducer
  },
});
